export enum REPORTS_TYPES {
  GET_REPORTS_REQUEST = '@reports/GET_REPORTS_REQUEST',
  SET_DATA_REPORTS = '@reports/SET_DATA_REPORTS',
  SET_ERROR = '@reports/SET_ERROR',
}

export interface Reports {
  response: any;
  hasMore?: boolean;
}
export interface ReportsState {
  reports: Reports;
  error: string;
}

export interface GetReports {
  period?: string;
  limit?: string;
  showMore?: boolean;
}

export interface Report {
  id: string;
  idBroker: string;
  pdvNumber: string;
  files: [];
  createdAt: string;
}
